<article class="page-container flex flex-column">
  <section>
    <button pButton icon="fas fa-plus" class="p-button-info p-button-outlined" [pTooltip]="screen.actions.add"
      (click)="openModal()">
    </button>
  </section>

  <section class="inline-flex">
    <p-table #dt [value]="people.content" [lazy]="true" (onLazyLoad)="lazyReadPeople($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="people.totalElements" [loading]="loading" dataKey="id" [contextMenu]="cm"
      [(contextMenuSelection)]="selectedPerson" (onContextMenuSelect)="setContextMenuItems()" class="col-12 p-0">

      <ng-template pTemplate="header">
        <tr>
          <th [attr.rowspan]="2" [style.width.px]="50"></th>
          <th [attr.rowspan]="2" [style.width.px]="50"></th>
          <th class="text-center" [style.width.px]="125"></th>
          <th class="text-center" [style.width.px]="175">{{screen.labels.document}}</th>
          <th class="text-center">{{screen.labels.name}}</th>
          <th class="text-center" [attr.rowspan]="2" [style.width.px]="200">{{screen.labels.age}}</th>
        </tr>
        <tr>
          <th [attr.colspan]="2">
            <input pInputText type="text" name="dtDocumentFilter" [(ngModel)]="dtDocumentFilter"
              (input)="dt.filter(dtDocumentFilter, 'document', 'contains')">
          </th>
          <th>
            <input pInputText type="text" name="dtNameFilter" [(ngModel)]="dtNameFilter"
              (input)="dt.filter(dtNameFilter, 'fullName', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-person let-expanded="expanded">
        <tr [pContextMenuRow]="person">
          <td class="text-center">
            <a href="#" [pRowToggler]="person">
              <i class="text-info fas" [ngClass]="{'fa-chevron-down': expanded, 'fa-chevron-right': !expanded}"></i>
            </a>
          </td>
          <td class="text-center">
            <i class="fas fa-circle {{person.status ? 'text-success' : 'text-danger'}}"
              [pTooltip]="person.status ? screen.labels.enabled : screen.labels.disabled"></i>
          </td>
          <td>{{person.documentTypeName}}</td>
          <td>{{person.document}}</td>
          <td>{{person.fullName}}</td>
          <td>
            <ms-string-split [toSplit]="person.age" [isDate]="true"></ms-string-split>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-person>
        <tr [pContextMenuRow]="person">
          <td [attr.colspan]="6">
            <div class="flex flex-column">
              <div class="form__field flex-row">
                <span class="col-4 inline-flex align-items-center justify-content-center">{{person.locationBornName}}</span>
                <span class="col-4 inline-flex align-items-center justify-content-center">{{person.genderName}}</span>
                <span class="col-4 inline-flex align-items-center justify-content-center">{{person.maritalStatusName}}</span>
              </div>

              <div class="form__field flex-row">
                <label
                  class="col-2 inline-flex align-items-start field__label strong no-margin">{{screen.labels.email}}</label>
                <span class="col-10 inline-flex">
                  <ms-string-split [toSplit]="person.email" [isEmail]="true"></ms-string-split>
                </span>
              </div>

              <div class="form__field flex-row">
                <label
                  class="col-2 inline-flex align-items-start field__label strong no-margin">{{screen.labels.phone}}</label>
                <span class="col-10 inline-flex">
                  <ms-string-split [toSplit]="person.phone" [isPhone]="true"></ms-string-split>
                </span>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="6">
            <span>{{screen.labels.emptyTable}}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="align-self-end">
    <ms-table-paged-footer [page]="people"></ms-table-paged-footer>
  </section>

  <p-contextMenu #cm [model]="options"></p-contextMenu>
</article>